import CopilotChannelProvider from './channel/CopilotChannelProvider';
import { jsx as _jsx } from "react/jsx-runtime";
const CopilotProvider = ({
  children,
  createLayer,
  instanceId
}) => {
  return /*#__PURE__*/_jsx(CopilotChannelProvider, {
    createLayer: createLayer,
    instanceId: instanceId,
    children: children
  });
};
export default CopilotProvider;